:host {
  display: flex;
  position: sticky;
  top: 0;
  grid-row: 1;
}

:host {
  background-color: inherit;
  margin-block-start: inherit;
  margin-block-end: inherit;
  border-block-start: inherit;
  border-block-end: inherit;
  padding-block-start: inherit;
  padding-block-end: inherit;
  transition: transform var(--column-drag-transition-duration, 0.2s);
}

:host {
  --ch-grid-column-z-index-head: var(--ch-grid-column-header-layer);
}

:host([show-settings]),
:host([resizing]) {
  --ch-grid-column-z-index-active: var(--ch-grid-column-active-layer);
}

:host([sort-direction=asc]) .bar .sort .sort-asc {
  visibility: visible;
}

:host([sort-direction=desc]) .bar .sort .sort-desc {
  visibility: visible;
}

.bar {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
}
.bar .selector {
  overflow: hidden;
  order: 0;
}
.bar .selector:not([hidden]) {
  display: flex;
}
.bar .name {
  display: flex;
  overflow: hidden;
  order: 1;
}
.bar .name .name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bar .sort {
  position: relative;
  align-items: center;
  order: 2;
}
.bar .sort:not([hidden]) {
  display: flex;
}
.bar .sort .sort-asc {
  visibility: hidden;
  animation-fill-mode: forwards;
}
.bar .sort .sort-desc {
  position: absolute;
  visibility: hidden;
  animation-fill-mode: forwards;
}
.bar .settings {
  order: 3;
}
.bar .resize {
  align-self: stretch;
  margin-inline-start: auto;
  order: 4;
}

@keyframes column-sort {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}